import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Import the datalabels plugin
import { useTheme, Box, useBreakpointValue } from '@chakra-ui/react';

// Register ChartJS elements and the datalabels plugin
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const CallDirectionChart = ({ directionData }) => {
  const theme = useTheme();  // Access Chakra UI theme
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [data, setData] = useState({ inbound: 0, outbound: 0 });

  useEffect(() => {
    if (directionData) {
      setData({
        inbound: parseFloat(directionData.inbound) || 0,
        outbound: parseFloat(directionData.outbound) || 0
      });
    }
  }, [directionData]);

  const total = data.inbound + data.outbound; // Calculate total for percentage

  const chartData = {
    labels: ['Inbound', 'Outbound'],
    datasets: [
      {
        label: 'Cost',
        data: [data.inbound, data.outbound],
        backgroundColor: [theme.colors.blue[300], theme.colors.teal[300]],  // Use Chakra colors
        hoverBackgroundColor: [theme.colors.blue[400], theme.colors.teal[400]],
        borderColor: [theme.colors.blue[500], theme.colors.teal[500]],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          boxWidth: 12,
          padding: 8,
          font: {
            size: isMobile ? 11 : 12
          },
          color: theme.colors.gray[700],
        },
      },
      datalabels: {
        formatter: (value) => {
          if (total === 0) return '0%';
          const percentage = ((value / total) * 100).toFixed(1);
          return `${percentage}%`;
        },
        color: 'white',
        font: {
          size: isMobile ? 14 : 16,
          weight: 'bold',
        },
      },
    },
    layout: {
      padding: {
        top: 0,
        bottom: 20,
        left: 0,
        right: 0
      }
    }
  };

  return (
    <Box 
      bg="white" 
      p={2}
      pt={4}
      borderRadius="md" 
      shadow="md" 
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <Box 
        flex="1"
        position="relative"
        minHeight={{ base: "280px", md: "320px" }}
        maxHeight={{ base: "350px", md: "350px" }}
        mt={-2}
      >
        <Pie data={chartData} options={options} />
      </Box>
    </Box>
  );
};

export default CallDirectionChart;
